/**
 * PortalToken
 *
 * Handles the setting and getting of the token to and from localstorage. It also returns the payload
 * of the token, and token value itself.
 */

// the constructor for this object
function PortalToken() { }

// the object
PortalToken.prototype = {
    constructor: PortalToken,

    // store the token
    setToken: function(token)
    {
        // get the expiration in days based on the current time, and token
        var payload = this.getPayload(token)
        var expiresAt = payload.expires_at;
        var now =  Math.floor(Date.now() / 1000);
        var expirationInDays = (expiresAt - now) / 86400;

        // store the token in a secure cookie
        Cookies.set('portalToken', token, {
            secure: PortalConfig.secureCookie,
            expires: expirationInDays
        });
    },

    // remove the token
    clearToken: function()
    {
        Cookies.remove('portalToken');
    },

    // get the token
    getToken: function()
    {
        if (Cookies.get('portalToken')) {
            return Cookies.get('portalToken');
        }

        return false;
    },

    // return the payload data from the token
    getPayload: function(token)
    {
        // get the token from the parameter, or storage
        if (token === undefined) {
            var token = this.getToken();
        }
        if (token == false) {
            return false;
        }

        // get the payload from the token
        var payload = token.split('.')[1];
        payload = atob(payload);
        payload = JSON.parse(payload);

        return payload;
    },

}
